import React, { useCallback } from 'react';
import { View, Text, TouchableHighlight, TouchableOpacity } from 'react-native';
import { crewCancellationCharges, JobDateData } from './types';
import { useRouter } from "expo-router";

interface JobDateItemProps {
  item: JobDateData;
}

const JobDateItem = ({ item }: JobDateItemProps) => {
  const router = useRouter();

  const itemPressed = useCallback(() => {
    router.push(`/home/${item.id}`);
  }, [item, router]);

  if (!item) {
    return (
      <View className='mx-4 my-1 px-4 py-3 bg-gray-50 rounded-xl justify-center'>
        <Text className='text-base text-gray-400 font-medium'>No Jobs Today</Text>
      </View>
    );
  }

  const canProvideFeedback = item.is_authed_crew_chief || item.is_flat_rate;
  const showFeedbackToBeCompleted = canProvideFeedback && item.is_past_date && !item.feedback_time_past && !item.is_all_feedback_complete;

  const crewCancelledCharge = crewCancellationCharges.find(c => c.value === item.crew_cancelled_charge)?.label || 'Unknown';
  return (
    <View className='mx-2 mt-2 rounded-md overflow-hidden border border-gray-200 bg-white'>
      <TouchableOpacity
        onPress={itemPressed}

        style={{
          backgroundColor: 'white',
        }}
      >
        <View className='p-4 flex-row items-center' style={{ backgroundColor: 'white' }}>
          <View className="min-w-[100px]">
            <Text className='text-black font-medium'>{item.start_time} - {item.end_time}</Text>
            {showFeedbackToBeCompleted && !item.is_cancelled && (
              <View className='mt-1 bg-red-50 px-2 py-1 rounded-md'>
                <Text className='text-red-500 text-xs font-medium'>Feedback required</Text>
              </View>
            )}

            {item.is_cancelled && (
              <View className='mt-1 bg-red-50 px-2 py-1 rounded-md'>
                <Text className='text-red-500 text-xs font-medium'>Cancelled</Text>
                {item.cancelled_charge !== 3 ? (
                  <Text className='text-red-500 text-xs font-medium'>{crewCancelledCharge}</Text>
                ) : (
                  <Text className='text-red-500 text-xs font-medium'>£{item.cancel_crew_amount}</Text>
                )}
              </View>
            )}
          </View>
          <View className='flex-1 ml-4 border-l border-gray-100 pl-4'>
            <Text className='text-black font-bold text-base'>{item.client_name}</Text>
            <Text className='text-gray-600 mt-1'>{item.venue_name}</Text>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default React.memo(JobDateItem);
